var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"value":_vm.value,"items":_vm.shopCollections,"loading":_vm.loading,"item-value":"id","return-object":false,"multiple":true},on:{"change":_vm.onChange},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.title)+" ")]}},{key:"item",fn:function(ref){
var item = ref.item;
var on = ref.on;
var attrs = ref.attrs;
var parent = ref.parent;
return [_c('v-list-item',_vm._g(_vm._b({},'v-list-item',attrs,false),on),[_c('v-list-item-action',[_c('v-simple-checkbox',{attrs:{"value":attrs.inputValue},on:{"change":function($event){return parent.$emit('select')}}})],1),_c('v-list-item-content',[_vm._v(" "+_vm._s(item.title)+" ")])],1)]}}])},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }